import {Injectable, Injector} from '@angular/core';
import {HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest} from '@angular/common/http';
import {Observable} from 'rxjs/Observable';
import {Router} from '@angular/router';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { of, throwError } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
    constructor(private router: Router) { }

    private handleAuthError(err: HttpErrorResponse): Observable<any> {
        if (err.status === 403) {
            this.router.navigateByUrl(`/permission-denied`);
            return of(err.message);
        }
        if (err.status === 401) {
            localStorage.clear();
            this.router.navigateByUrl(`/login`);
            return of(err.message);
        }
        // Other errors (e.g. 422 validation / invalid MFA code) must propagate
        // to the caller's error handler instead of returning undefined, which
        // would break the RxJS stream ("undefined where a stream was expected").
        return throwError(err);
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).catch(err => this.handleAuthError(err));

    }
}